import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function HumanResources() {
    return (
        <main className="bg-gradient-to-b from-slate-900 to-black text-gray-100 py-16 overflow-hidden">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
                <div className="flex-1 z-10">
                    <h1 className="text-4xl font-bold text-white">Human Resources Solutions</h1>
                    <p className="mt-4 text-lg text-gray-300 leading-relaxed">
                        SecureID Technologies supports HR departments with identity verification,
                        onboarding automation, and compliance tracking solutions. Our software
                        helps organizations streamline background checks and exam certifications
                        for candidates and employees.
                    </p>

                    <ul className="mt-6 list-disc pl-6 text-gray-300 space-y-2">
                        <li>Integrated Live Scan fingerprinting</li>
                        <li>Digital consent and record storage</li>
                        <li>Exam and certification management</li>
                        <li>Employee onboarding and offboarding automation</li>
                    </ul>

                    <p className="mt-10 text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </div>

                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, x: 200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2 }}
                >
                    <img
                        src="/Images/industry-hr.jpg"
                        alt="HR industry illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl"
                    />
                </motion.div>
            </section>
        </main>
    );
}
